var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcWcagTextLarge = function SvgIcWcagTextLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "20px",
    viewBox: "0 0 52 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-1828.000000, -19.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rozmiar-fontu",
    transform: "translate(1624.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.847661,20 L210.273051,15.9312321 L218.340757,15.9312321 L219.737639,20 L223.985301,20 L216.601782,0 L212.012027,0 L204.6,20 L208.847661,20 Z M217.257461,12.8653295 L211.32784,12.8653295 L214.29265,4.32664756 L217.257461,12.8653295 Z M234.33363,17.1060172 L234.33363,11.6618911 L239.664588,11.6618911 L239.664588,7.96561605 L234.33363,7.96561605 L234.33363,2.49283668 L230.45657,2.49283668 L230.45657,7.96561605 L225.125612,7.96561605 L225.125612,11.6618911 L230.45657,11.6618911 L230.45657,17.1060172 L234.33363,17.1060172 Z M250.469042,17.1060172 L250.469042,11.6618911 L255.8,11.6618911 L255.8,7.96561605 L250.469042,7.96561605 L250.469042,2.49283668 L246.591982,2.49283668 L246.591982,7.96561605 L241.261024,7.96561605 L241.261024,11.6618911 L246.591982,11.6618911 L246.591982,17.1060172 L250.469042,17.1060172 Z",
    id: "A++"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcWcagTextLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_wcag_text_large.07bc04f8.svg";
export { ForwardRef as ReactComponent };